<template>
  <div class="container-fluid margin-9apuap">
      <h1>Contact Info</h1>
    <p>Legal address:Themistokli Dervi, 17-19 THE CITY HOUSE, 2nd floor 1066, Nicosia,
        Cyprus</p>
  </div>



</template>

<script>

   
    export default {
        name: 'contact',
        components: {
          
        },
        props: {
         
        },
        data(){
            return {
               
           
            }
        },
        mounted(){
            
        },
        methods:{
          
        },
        computed:{
            
        },
        watch:{
           
        },
    }
</script>